import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const CLEAR_CONTENT = 'CLEAR_CONTENT';
export const SET_TABLE = 'SET_TABLE';
export const SET_IS_SHOW_KNOB = 'SET_IS_SHOW_KNOB';
export const SET_IS_SIDE_BAR_DRAWER_OPEN = 'SET_IS_SIDE_BAR_DRAWER_OPEN';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[CLEAR_CONTENT](state) {
		Vue.set(state.content, 'tableViewer', {});
	},
	[SET_TABLE](state, payload) {
		const { title, data } = payload;
		Vue.set(state.content.tableViewer, title, data);
	},
	[SET_IS_SHOW_KNOB](state, payload) {
		Vue.set(state, 'isShowKnob', payload);
	},
	[SET_IS_SIDE_BAR_DRAWER_OPEN](state, payload) {
		Vue.set(state, 'isSideBarDrawerOpen', payload);
	},
};

export default mutations;
